import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import {
	SliderWrapper,
	Slider,
	PrevBtn,
	NextBtn,
	MobileCircleWrapper,
	Circle,
} from "./HeroStyles";
import CaretRight from "./CaretLargeRight";
import { ResponsiveCheck } from "core/providers/Responsive";
import Slide from './HeroSlide';
import SliderHOC from 'holiday_hub/SliderHOC';
import { featuredCardProps } from 'core/utils';

const HeroSlider = ({ slides }) => (
	<SliderHOC slides={slides}>
		{({
			index,
			onTouchStart,
			onTouchEnd,
			onTouchMove,
			handleMouseEnter,
			handleMouseLeave,
			previous,
			next,
			goTo,
		}) => (
			<ResponsiveCheck>
				{({ isDesktop }) => (
					<>
						<SliderWrapper
							onTouchStart={onTouchStart}
							onTouchMove={onTouchMove}
							onTouchEnd={onTouchEnd}
							onMouseEnter={handleMouseEnter}
							onMouseLeave={handleMouseLeave}
							id="hero-slider"
						>
							<Slider>
								{slides.map((slide, idx) => (
									<Slide key={idx} slide={slide} idx={idx} index={index} />
								))}

							</Slider>
							{slides.length && isDesktop && (
								<Fragment>
									<PrevBtn onClick={previous} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
										<CaretRight />
									</PrevBtn>
									<NextBtn onClick={next} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
										<CaretRight />
									</NextBtn>
								</Fragment>
							)}
						</SliderWrapper>

						<MobileCircleWrapper>
							{slides.map((_, idx) => (
								<Circle
									key={idx}
									active={index === idx}
									onClick={goTo(idx)}
								/>
							))}
						</MobileCircleWrapper>
					</>
				)}
			</ResponsiveCheck>
		)}
	</SliderHOC>
);

HeroSlider.propTypes = {
	slides: PropTypes.arrayOf(PropTypes.shape(featuredCardProps))
};

HeroSlider.defaultProps = {};

export default HeroSlider;
